import "core-js/modules/es.function.name.js";
import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/no-img-video.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-81f38bac"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  class: "alonePlay-playlist"
};
var _hoisted_2 = ["onClick"];

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_4 = ["innerHTML"];
var _hoisted_5 = {
  key: 2,
  class: "songe"
};
var _hoisted_6 = ["innerHTML"];

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "animatIcon"
  }, [/*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-play"
  })], -1
  /* HOISTED */
  );
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_image = _resolveComponent("el-image");

  var _component_PlayListBefore = _resolveComponent("PlayListBefore");

  var _component_Loading = _resolveComponent("Loading");

  var _directive_infinite_scroll = _resolveDirective("infinite-scroll");

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    id: "videoList",
    style: _normalizeStyle([{
      "overflow": "auto"
    }, {
      width: '100%',
      height: _ctx.isScroll ? '480px' : '100%'
    }]),
    "infinite-scroll-distance": 200,
    "infinite-scroll-immediate": false
  }, [_ctx.videoList.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 每个视频item "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videoList, function (item) {
    var _item$creator$, _item$creator$2;

    return _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "alone-play-item",
      key: item,
      onClick: function onClick($event) {
        return _ctx.mvClick(item.id || item.vid);
      }
    }, [_createCommentVNode(" 图片 "), _createVNode(_component_el_image, {
      fit: "fill",
      src: item.coverUrl || item.imgurl
    }, {
      placeholder: _withCtx(function () {
        return [_hoisted_3];
      }),
      _: 2
      /* DYNAMIC */

    }, 1032
    /* PROPS, DYNAMIC_SLOTS */
    , ["src"]), _createVNode(_component_PlayListBefore, {
      playCount: item.playTime || item.playCount,
      playTime: item.durationms || item.duration
    }, null, 8
    /* PROPS */
    , ["playCount", "playTime"]), _createCommentVNode(" 视频名称 "), !_ctx.inputValue ? (_openBlock(), _createElementBlock("p", {
      key: 0,
      class: _normalizeClass(['paylist-item-title', _ctx.isBlod ? 'linelittle' : 'morelittle', _ctx.isBlod && 'blod'])
    }, _toDisplayString(item.title || item.name), 3
    /* TEXT, CLASS */
    )) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createCommentVNode(" 视频名称高亮 "), _createElementVNode("p", {
      class: _normalizeClass(['paylist-item-title', _ctx.isBlod ? 'linelittle' : 'morelittle', _ctx.isBlod && 'blod']),
      innerHTML: _ctx.lightKeyword(item.title, _ctx.inputValue)
    }, null, 10
    /* CLASS, PROPS */
    , _hoisted_4)], 2112
    /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
    )), _createCommentVNode(" 视频作者 "), item.creator && !_ctx.inputValue ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.creator.nickname || ((_item$creator$ = item.creator[0]) === null || _item$creator$ === void 0 ? void 0 : _item$creator$.userName)), 1
    /* TEXT */
    )) : item.creator && _ctx.inputValue ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 3
    }, [_createCommentVNode(" 视频作者高亮 "), _createElementVNode("span", {
      class: "songe",
      innerHTML: _ctx.lightKeyword(item === null || item === void 0 ? void 0 : (_item$creator$2 = item.creator[0]) === null || _item$creator$2 === void 0 ? void 0 : _item$creator$2.userName, _ctx.inputValue)
    }, null, 8
    /* PROPS */
    , _hoisted_6)], 2112
    /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
    )) : _createCommentVNode("v-if", true), _createCommentVNode(" 动画图标 "), _hoisted_7], 8
    /* PROPS */
    , _hoisted_2)), [[_vShow, item.title || item.name]]);
  }), 128
  /* KEYED_FRAGMENT */
  )), _withDirectives(_createVNode(_component_Loading, {
    setHeight: 50,
    style: {
      "margin": "0 auto"
    }
  }, null, 512
  /* NEED_PATCH */
  ), [[_vShow, _ctx.isShowLoading]])])) : (_openBlock(), _createBlock(_component_Loading, {
    key: 1
  }))], 4
  /* STYLE */
  )), [[_directive_infinite_scroll, _ctx.scrollLoad]]);
}